import { motion } from 'framer-motion'
import { Quote } from 'lucide-react'
import { testimonials } from '../data.ts'
import SectionHeading from './SectionHeading.tsx'
import React from 'react'

export default function Testimonials() {
  return (
    <section id="about" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="About Raag"
          title={<>Loved by the <span className="text-gradient">businesses we build for</span></>}
          subtitle="We're a small, senior team obsessed with craft and outcomes. Here's what our clients say."
        />

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
              className="relative rounded-2xl border border-white/10 bg-white/[0.03] p-7"
            >
              <Quote size={28} className="text-brand-500/40" />
              <blockquote className="mt-4 text-base leading-relaxed text-slate-200">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className="grid h-11 w-11 place-items-center rounded-full bg-gradient-to-br from-brand-400 to-brand-600 text-sm font-bold text-ink-950">
                  {t.initials}
                </span>
                <div>
                  <div className="font-semibold text-white">{t.name}</div>
                  <div className="text-sm text-slate-400">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  )
}
